// extracted by mini-css-extract-plugin
module.exports = {"overviewSVG":"MessageParserDocs_overviewSVG__RkbIQ","infoBoxParagraph":"MessageParserDocs_infoBoxParagraph__dmHUc"};